import './public-path';

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import IcbuBuyerPcTopBanner from '@ali/icbu-buyer-pc-top-banner';

import PageStore from '@/stores/page';

import Header from '@/module/header';
import Log from '@/module/log';
import Quick from '@/module/quick';
import Structure from '@/module/structure';
import SubMenu from '@/module/sub-menu';

import AutoExp from '@/common/auto-log';
import countrySite from '@/common/country-site';
import MyLazyComponent from '@/common/lazy-load';
import xman from '@/common/xman';

import ErrorBoundary from './common/error-boundary';
import getPageUtils from './page-utils';
import isNodeServer from './utils/isNodeServer';

import './styles/index.less';

// 增加滚动效果
const Root = (props: DetailTypes.Root) => {
  const { globalData, nodeMap } = props;

  const handleLoad = () => {
    AutoExp();
  };

  const pageStore = PageStore(state => state);
  const { isLoaded } = pageStore;

  useEffect(() => {
    // 主图失去焦点，右侧浮动
    if (!window.__getComponentInNode) return;
    // 加载xman
    window.addEventListener('load', () => xman());
    document.addEventListener('DOMContentLoaded', handleLoad);
    // 初始化全局方法
    getPageUtils().init();
  }, []);

  // Quick View
  if (props.renderId === 'quick-detail' || nodeMap?.module_quick_right) {
    return <Quick {...props} />;
  }

  const Footer = MyLazyComponent(() => import(/* webpackChunkName: "footer" */ './module/footer'));
  const Breadcrumb = MyLazyComponent(
    () => import(/* webpackChunkName: "breadcrumb" */ './module/breadcrumb')
  );

  const renderHeader = () => {
    // 兼容逻辑，同构段不出 header
    if (window.__getComponentInNode) return null;
    // @ts-ignore 临时兼容发布添加的变量，需要删除
    if (!window.staticHeaderHtml) {
      return (
        <header id="icbu-header">
          <IcbuBuyerPcTopBanner data={globalData.extend.banner} />
          <Header
            showSA={globalData.extend.showSA}
            productId={globalData.product.productId}
            i18n={globalData.i18n}
            abtest={globalData.abtest}
          />
        </header>
      );
    }
  };

  return (
    <>
      {renderHeader()}
      <ErrorBoundary>
        <Structure {...props} />
      </ErrorBoundary>

      {isLoaded && <Breadcrumb breadCrumb={globalData.seo.breadCrumb} i18n={globalData.i18n} />}
      {isLoaded && <Footer />}
    </>
  );
};

if (isNodeServer()) {
  window.__getComponentInNode(Root);
} else {
  // Quick view 跨域打点支持
  if (
    window.location.search.indexOf('channel=log') > -1 ||
    window.location.search.indexOf('only=log') > -1
  ) {
    ReactDOM.render(<Log />, document.getElementById(window.detailData.renderId || 'container'));
  } else {
    ReactDOM.render(
      <Root {...(window.detailData as DetailTypes.Root)} />,
      document.getElementById(window.detailData.renderId || 'container')
    );
  }
}
